// KWANKGM11020_事前審査結果入力（承認・不承認）（職員）

// 承認・不承認の値(承認状態コードに準拠)
export const approval_value = {
  agree: '01',
  disagree: '02',
}

// デフォルトの案内文章
export const default_notice = {
  agree: 'お申込みの内容で審査承認となりました。借入申込のお手続きをお願いします。',
  disagree: '誠に申し訳ございませんが、今回はお見送りとさせていただきます。',
};

// payloadのdetailにセットするID
export const detail_id = 9999;
